/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { hubSpotLinkSearch } from '../../axios/hubSpotLinkSearch'
import type {
	HubSpotLinkSearchError,
	HubSpotLinkSearchPathParams,
	HubSpotLinkSearchQueryParams,
	HubSpotLinkSearchResponse,
} from '../../types/HubSpotLinkSearch'

export const hubSpotLinkSearchQueryKey = (
	organisation: HubSpotLinkSearchPathParams['organisation'],
	params?: HubSpotLinkSearchQueryParams,
) => [{ url: '/:organisation/hubspot/search', params: { organisation } }, ...(params ? [params] : [])] as const

export type HubSpotLinkSearchQueryKey = ReturnType<typeof hubSpotLinkSearchQueryKey>

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::search */
export function hubSpotLinkSearchQueryOptions(
	organisation: HubSpotLinkSearchPathParams['organisation'],
	params?: HubSpotLinkSearchQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		HubSpotLinkSearchResponse,
		AxiosError<HubSpotLinkSearchError>,
		HubSpotLinkSearchResponse,
		HubSpotLinkSearchQueryKey
	>({
		queryKey: hubSpotLinkSearchQueryKey(organisation, params),
		queryFn: ({ signal }) => hubSpotLinkSearch(organisation, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::search */
export function useHubSpotLinkSearch<TSelectData = HubSpotLinkSearchResponse>(
	organisation: HubSpotLinkSearchPathParams['organisation'],
	params?: HubSpotLinkSearchQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					HubSpotLinkSearchResponse,
					AxiosError<HubSpotLinkSearchError>,
					TSelectData,
					HubSpotLinkSearchQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<HubSpotLinkSearchError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...hubSpotLinkSearchQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::search */
export function useHubSpotLinkSearchSuspense<TSelectData = HubSpotLinkSearchResponse>(
	organisation: HubSpotLinkSearchPathParams['organisation'],
	params?: HubSpotLinkSearchQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					HubSpotLinkSearchResponse,
					AxiosError<HubSpotLinkSearchError>,
					TSelectData,
					HubSpotLinkSearchQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<HubSpotLinkSearchError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...hubSpotLinkSearchQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
